<template>
<div>



    <el-row>
        <el-col :span="20">
            <div class="grid-content bg-purple-light" >
                <div class="searchTitle2">
                    <b style="font-size: 20px !important;"> 고객정보 생성  </b>
                </div>
          <!-- 조회 조건 영역 -->

                <div class="searchBody">
                    <div class="searchBody_year" style="font-size: 15px !important;" >
                        업체명
                    </div>
                    <div class="searchBody">
                        <el-input
                                class="wide-input"
                                style="margin-left: 10px;"
                                placeholder=""
                                v-model="deptNameInput"
                        >
                        </el-input>
                    </div>
                    <div class="searchBody">
                        <div
                                class="searchBody_brand"
                                style="margin-left: 10px !important;"
                        >
                            <el-button
                                    :loading="loading"
                                    type="primary"

                                    @click="deptSave"
                            >저장</el-button>

                        </div>
                    </div>
                </div>
        </div> <!-- div class="grid-content bg-purple-light"> -->
      </el-col>

    </el-row>


<el-row>
    <el-col :span="20">
      <div class="grid-content bg-purple-light"  >

          <div class="searchTitle2">
              <b style="font-size: 20px !important;"> 고객정보 조회  </b>
          </div>
        <!-- 조회 조건 영역 -->


          <div class="searchBody">
              <div class="searchBody_year" style="font-size: 15px !important;">
                  업체명
              </div>
              <div class="searchBody">
                  <el-input
                          class="wide-input"
                          style="margin-left: 10px;"
                          placeholder=""
                          v-model="dept_name"
                  >
                  </el-input>
              </div>
              <div class="searchBody">
                  <div
                          class="searchBody_brand"
                          style="margin-left: 10px !important;"
                  >
                      <el-button
                              :loading="loading"
                              type="primary"
                              @click="search(true)"
                              icon="el-icon-search"
                      >조회</el-button
                      >
                  </div>
              </div>
          </div>
      </div> <!-- div class="grid-content bg-purple-light"> -->
    </el-col>
</el-row>

    <el-row>
        <el-col :span="20">
            <div class="grid-content bg-purple-light"  >

    * 여러국가 언어 설정방법 *
    <br>
    국가구분  1로 되어 있는데 2개국이면 2, 3개국이면 3으로 변경
    <br>
    국가1에는 넣을필요 없고 2, 3부터 언어 설정
    "en": 영어
    "es": 스페인어
    "fr": 프랑스어
    "de": 독일어
    "ja": 일본어
    "ko": 한국어
    "zh": 중국어
    "vi": 베트남
    "ru": 러시아

    <br>

    백그라운드이미지는 "번호.png" 이며 두번째 국가부터는
    "번호_2.png", "번호_3.png" 로 설정



     <el-table
             v-loading="loading"
             ref="multipleTable"
             :data="tableData"
             style="width: 100%; height:100%"
             border
             @selection-change="handleSelectionChange"
             :row-class-name="tableRowClassName"
             size="small"
             :row-style="{ height: 0 + 'px' }"
             :cell-style="{ padding: 0 + 'px' }"
             :header-cell-style="{
                          background: '#2F384E',
                          color: '#fff',
                          height: '10px',
                          padding: '0px',
                        }"
     >
    <el-table-column
      type="selection"
      width="35"
      >
    </el-table-column>

    <el-table-column
      property="rfid_get_order_seq"
      label="번호"
      width="50">
    </el-table-column>



   <el-table-column
       label="업체명"
       width="240">

     <template slot-scope="scope">
       <el-input id ='dept_name' placeholder="Please input" v-model="scope.row.dept_name" ></el-input>
     </template>

   </el-table-column>



    <el-table-column
      label="ERROR COUNT"
      width="100">

       <template slot-scope="scope">
        <el-input placeholder="Please input" v-model="scope.row.error_limit"></el-input>
       </template>

    </el-table-column>


   <el-table-column
       label="국가구분(최대3까지)"
       width="130">
       <template slot-scope="scope">
           <el-input placeholder="Please input" v-model="scope.row.contry_flag"></el-input>
       </template>
   </el-table-column>



     <el-table-column
             label="국가2"
             width="100">
         <template slot-scope="scope">
             <el-input placeholder="Please input" v-model="scope.row.contry_2"></el-input>
         </template>
     </el-table-column>


     <el-table-column
             label="국가3"
             width="100">
         <template slot-scope="scope">
             <el-input placeholder="Please input" v-model="scope.row.contry_3"></el-input>
         </template>
     </el-table-column>


     <el-table-column
       label="USER ID"
       width="200">
     <template slot-scope="scope">
       <el-input    id="user_id"  placeholder="Please input" v-model="scope.row.user_id" ></el-input>
     </template>
   </el-table-column>


   <el-table-column
       label="비번 "
       width="200">
     <template slot-scope="scope">
       <el-input id="user_id"   placeholder="Please input" v-model="scope.row.password"></el-input>
     </template>
   </el-table-column>


   <el-table-column
       label="국가1 (세번째칸)"
       width="220">
     <template slot-scope="scope">
       <el-input id="link_url_1"   placeholder="Please input" v-model="scope.row.link_message_1"></el-input>
     </template>
   </el-table-column>



   <el-table-column
       label="URL1 (세번째칸)"
       width="220">
     <template slot-scope="scope">
       <el-input id="link_url_1"   placeholder="Please input" v-model="scope.row.link_url_1"></el-input>
     </template>

   </el-table-column>


   <el-table-column
       label="국가1 (네번째칸)"
       width="220">

     <template slot-scope="scope">
       <el-input id="link_url_1"   placeholder="Please input" v-model="scope.row.link_message_2"></el-input>
     </template>

   </el-table-column>



   <el-table-column
       label="URL1 (네번째칸)"
       width="220">

     <template slot-scope="scope">
       <el-input id="link_url_1"   placeholder="Please input" v-model="scope.row.link_url_2"></el-input>
     </template>

   </el-table-column>



     <el-table-column
             label="국가2 (세번째칸)"
             width="220">

         <template slot-scope="scope">
             <el-input id="link_url_1"   placeholder="Please input" v-model="scope.row.link_message_3"></el-input>
         </template>

     </el-table-column>



     <el-table-column
             label="URL2 (세번째칸)"
             width="220">

         <template slot-scope="scope">
             <el-input id="link_url_1"   placeholder="Please input" v-model="scope.row.link_url_3"></el-input>
         </template>

     </el-table-column>


     <el-table-column
             label="국가2 (네번째칸)"
             width="220">

         <template slot-scope="scope">
             <el-input id="link_url_1"   placeholder="Please input" v-model="scope.row.link_message_4"></el-input>
         </template>

     </el-table-column>



     <el-table-column
             label="URL2 (네번째칸)"
             width="220">

         <template slot-scope="scope">
             <el-input id="link_url_1"   placeholder="Please input" v-model="scope.row.link_url_4"></el-input>
         </template>

     </el-table-column>


     <el-table-column
             label="국가3 (세번째칸)"
             width="220">

         <template slot-scope="scope">
             <el-input id="link_url_1"   placeholder="Please input" v-model="scope.row.link_message_5"></el-input>
         </template>

     </el-table-column>



     <el-table-column
             label="URL3 (세번째칸)"
             width="220">

         <template slot-scope="scope">
             <el-input id="link_url_1"   placeholder="Please input" v-model="scope.row.link_url_5"></el-input>
         </template>

     </el-table-column>


     <el-table-column
             label="국가3 (네번째칸)"
             width="220">

         <template slot-scope="scope">
             <el-input id="link_url_1"   placeholder="Please input" v-model="scope.row.link_message_6"></el-input>
         </template>

     </el-table-column>



     <el-table-column
             label="URL3 (네번째칸)"
             width="220">

         <template slot-scope="scope">
             <el-input id="link_url_1"   placeholder="Please input" v-model="scope.row.link_url_6"></el-input>
         </template>

     </el-table-column>



   <el-table-column
       label="버튼 색상"
       width="100">

     <template slot-scope="scope">
       <el-input placeholder="Please input" v-model="scope.row.button_color"></el-input>
     </template>

   </el-table-column>

   <el-table-column
       label="버튼 margin"
       width="100">

     <template slot-scope="scope">
       <el-input placeholder="Please input" v-model="scope.row.button_margin_top"></el-input>
     </template>

   </el-table-column>



     <el-table-column
             label="버튼 글자 색상"
             width="100">

         <template slot-scope="scope">
             <el-input placeholder="Please input" v-model="scope.row.button_font_color"></el-input>
         </template>

     </el-table-column>


 </el-table>




    <el-row>
        <el-col :span="24"><div class="pagination"  >

            <el-pagination
                    small
                    layout="prev, pager, next"
                    :total="totalSize"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-size="pageSize"
            >
            </el-pagination>

            <el-button
                    :loading="loading"
                    type="primary"
                    @click="dialogVisible = true"
            >변경 저장</el-button>


            <el-button
                    :loading="loading"
                    type="primary"
                    @click="remove"
            >삭제</el-button>

        </div>
        </el-col>
    </el-row>


            </div> <!-- div class="grid-content bg-purple-light"> -->
        </el-col>
    </el-row>





    <el-dialog
      :visible.sync="dialogVisible"
      width="25%"
      height="50px"
      :before-close="handleClose">
    <span>저장 하시겠습니까 ?</span>
    <span slot="footer" class="dialog-footer">
    <div class="searchBody">
        <el-button style ="margin-left: 150px" type="primary" @click="save">OK</el-button>
        <el-button type="primary" @click="dialogVisible = false">Cancel</el-button>
    </div>
    </span>
  </el-dialog>

</div>




</template>

<script>
import Axios from 'axios';

  export default {
    created() {

      document.onkeydown = this.NotReload;


      this.$store.commit("dayBefore",0);
      this.requestEndDateOption = this.$store.state.dateOption; // 조회조건에서 현재 날짜
      this.$store.commit("dayBefore",7);
      this.requestStartDateOption = this.$store.state.dateOption; // 조회조건이서 현재보다 -7 일

      // this.$store.state.accessToken

      if (this.$store.state.userId != 'admin') {
        this.deptSeqOption = this.$store.state.deptSeq;
        this.deptNameOption = this.$store.state.deptName;
      }


      // 페이지로딩시 조회
      this.search();

    },//created
    data() {
      return {
        // table 관련 data
        tableData: [],
        totalData: [],
        multipleSelection: [],
        currentPage: 1,
        pageSize:10,
        totalSize:0,
        // loading 변수 true 이면 loging 화면 보여줌
        loading:false,
        // 조회조건 관련 변수
        brandOptions: [{
          value: 'CW',
          label: 'CW'
        }, {
          value: 'KO',
          label: 'KO'
        }, {
          value: 'CM',
          label: 'CM'
        }, {
          value: 'KS',
          label: 'KS'
        },],
        brandOption: '',
        styleOption :'',
        deptNameOption:'',
        deptSeqOption:0,
        requestStartDateOption:'',
        requestEndDateOption:'',
        statusOption:'',
        loss:'3',
        deptNameDisabled:'false',
        dialogVisible: false,
        deptNameInput : '',
          dept_name : '',
      }
    },//data//

    methods: {



      deptSave(){
        let url = "";
        url = this.$url + '/rfidGetOrder/insert';
        const reqJson=[];
        this.loading = true;

        if ( this.deptNameInput  == '' || this.deptNameInput  == null )
        {
          this.$message.error("업체명을 입력해주세요 ");
          this.loading = false;
          return ;
        }


          reqJson.push({
            dept_name : this.deptNameInput
          });


        Axios.post(url, reqJson , this.$store.state.config  ).then(res => {

          //console.log(res);
          let saveCount = res.data;
          this.loading = false;
          this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
          this.search();
          // this.$refs.myFiles.files[0].name = null;
        }).catch(error => {
          console.log(error.response)
          this.$message.error(this.$store.state.serverErrorMessage);
          this.currentPage = 1;
          this.loading = false;
        }); // await Axios.post

      }, // save


      NotReload() {
        if ((event.ctrlKey == true && (event.keyCode == 78 || event.keyCode == 82)) || (event.keyCode == 116)) {
          event.keyCode = 0;
          event.cancelBubble = true;
          event.returnValue = false;
        }
      },

      handleClose() {
        this.dialogVisible = false;
      },

      async search(){
        this.loading = true;

        let url = this.$url + '/rfidGetOrder/list';
        var reqJson = new Object();


        reqJson.brand = this.brandOption;
        reqJson.style = this.styleOption;
        reqJson.dept_seq = this.deptSeqOption;
        reqJson.request_start_date = this.requestStartDateOption;
        reqJson.request_end_date = this.requestEndDateOption;
          reqJson.dept_name                         = this.dept_name;

        await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
          var resDataJson = res.data.rfidGetOrderDto
          this.totalData=[];
          if (res.data.resultCode){
            for(var resData in resDataJson){
              this.totalData.push({
                  seq : resData
                , rfid_get_order_seq: resDataJson[resData]['rfid_get_order_seq']
                , style: resDataJson[resData]['style']
                , color: resDataJson[resData]['color']
                , size: resDataJson[resData]['size']
                , order_degree: resDataJson[resData]['order_degree']
                , brand: resDataJson[resData]['brand']
                , product_amount: resDataJson[resData]['product_amount']
                , rfid_order_amount: resDataJson[resData]['rfid_order_amount']
                , rfid_order_confirm_amount: resDataJson[resData]['rfid_order_confirm_amount']
                , rfid_take_amount: resDataJson[resData]['rfid_take_amount']
                , request_date: resDataJson[resData]['request_date']
                , dept_name: resDataJson[resData]['dept_name']
                , dept_seq: resDataJson[resData]['dept_seq']
                , take_date: resDataJson[resData]['take_date']
                , error_limit : resDataJson[resData]['error_limit']
                , auth_gubun : resDataJson[resData]['auth_gubun']
                , user_id  : resDataJson[resData]['user_id']
                , password  : resDataJson[resData]['password']
                , user_seq : resDataJson[resData]['user_seq']
                , link_message_1 : resDataJson[resData]['link_message_1']
                , link_url_1 : resDataJson[resData]['link_url_1']
                , link_message_2 : resDataJson[resData]['link_message_2']
                , link_url_2 : resDataJson[resData]['link_url_2']
                , button_margin_top : resDataJson[resData]['button_margin_top']
                , button_color : resDataJson[resData]['button_color']
                , button_border_color :  resDataJson[resData]['button_border_color']
                  , button_font_color : resDataJson[resData]['button_font_color']
                  , contry_flag : resDataJson[resData]['contry_flag']
                  , contry_1 : resDataJson[resData]['contry_1']
                  , contry_2 : resDataJson[resData]['contry_2']
                  , contry_3 : resDataJson[resData]['contry_3']
                  , link_url_3 : resDataJson[resData]['link_url_3']
                  , link_url_4 : resDataJson[resData]['link_url_4']
                  , link_url_5 : resDataJson[resData]['link_url_5']
                  , link_url_6 : resDataJson[resData]['link_url_6']

                  , link_message_3 : resDataJson[resData]['link_message_3']
                  , link_message_4 : resDataJson[resData]['link_message_4']
                  , link_message_5 : resDataJson[resData]['link_message_5']
                  , link_message_6 : resDataJson[resData]['link_message_6']
              });
            }
            // 전체 데이터 사이즈
            this.totalSize = this.totalData.length;
            // 보여주는 부분만 slice
            this.tableData = this.totalData.slice(0, this.pageSize);
            this.currentPage = 1;
            this.loading = false;
            this.$message.success(this.$store.state.searchSuccess);
          }else {
            this.$message.error(this.$store.state.dataNotFound);
            this.currentPage = 1;
            this.loading = false;
          }
        }) // await Axios.post
        .catch(error => {
          console.log(error.response)
          this.$message.error(this.$store.state.serverErrorMessage);
          this.currentPage = 1;
          this.loading = false;
        }); // await Axios.post
      },//search

      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      }, //toggleSelection

      // check box click event
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      tableRowClassName({row, rowIndex}) {
        if (rowIndex === 1) {
        //  return 'warning-row';
        } else if (rowIndex === 3) {
        //  return 'success-row';
        }
         console.log(row);
        return '';
      },
      handleSizeChange(val) {
        console.log(`${val} items per page`);
      },

      // pagging event
      handleCurrentChange(val) {
        this.tableData = this.totalData.slice( (this.pageSize * val - this.pageSize )   , this.pageSize * val);
      },


      save(){

        if (this.multipleSelection.length <= 0)
        {
          this.$message.error(this.$store.state.noDataSelect);
          return ;
        }
        this.dialogVisible = false;
        this.loading = true;
        let url = "";
        url = this.$url + '/rfidGetOrder/update';
        // const json = { 'user_id': this.$store.state.userId };

        // for(var resData in this.multipleSelection){
        //   this.multipleSelection[resData]['address1'] = this.$store.state.address1
        //   this.multipleSelection[resData]['address2'] = this.$store.state.address2
        //   this.multipleSelection[resData]['reg_user_id'] = this.$store.state.userId
        //   this.multipleSelection[resData]['upd_user_id'] = this.$store.state.userId
        //   this.multipleSelection[resData]['rfid_order_confirm_amount'] =  this.multipleSelection[resData]['rfid_order_confirm_amount'] *=1;
        // }

        Axios.post(url,
                      this.multipleSelection
                    , this.$store.state.config ).then(res => {

          // console.log("=========================Axios.pos.SAVE================================" );
          // console.log(res.data);

          let saveCount = res.data;
          this.loading = false;
          this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
          this.search(false);

        }).catch(error => {
          console.log(error.response)
          this.$message.error(this.$store.state.serverErrorMessage);
          this.currentPage = 1;
          this.loading = false;
        }); // await Axios.post
      }, // save

      percent(){

        for(var resData in this.tableData) {
          this.tableData[resData]['rfid_order_amount'] =  Math.ceil(this.tableData[resData]['rfid_order_amount'] * 1.03 );
        }

      },


      async remove(){
        if (this.multipleSelection.length <= 0)
        {
          this.$message.error("데이터를 선택하세요 ");
          return ;
        }
        this.loading = true;
        let url = "";
        url = this.$url + '/rfidGetOrder/removeUpdate';
        const config = {
          ...this.$store.state.config,
          headers: {
            ...this.$store.state.config.headers,
            Authorization: `Bearer ${this.$store.state.accessToken}`
          }
        };
        Axios.post(url, this.multipleSelection, config).then(res => {

          //console.log(res );
          let saveCount = res.data;
          this.loading = false;
          this.$message.success(saveCount +'건 삭제 되었습니다.');
          this.search(false);

        }).catch(error => {
          console.log(error.response)
          this.$message.error(this.$store.state.serverErrorMessage);
          this.currentPage = 1;
          this.loading = false;
        }); // await Axios.post
      }, // remove


    }, //methods
  } // export default
</script>


<style>

#lossInput {
  height: 20px !important;
  width : 70px  !important;
  border: 1px solid #f29659 !important;
  border-radius: 4px !important;
  box-sizing: border-box !important;
  /* // font-family: Segoe UI,Malgun Gothic !important;
  // font-weight: 400 !important; */
  font-size: 9px !important;
  cursor: pointer !important;
  padding: 0 6px !important;
  margin-left: 100px !important;
}

#percent{
  height: 20px !important;
  align-items: center !important;
  display: flex !important;
}

.el-dialog__header {
   padding: 0px !important;
}

el-dialog__footer {
  padding: 0px !important;
}

#deptNameInput {
  height: 20px !important;
  width: 250px !important;
  border: 1px solid #2C5AA0 !important;
  border-radius: 4px !important;
  box-sizing: border-box !important;
  font-size: 9px !important;
  padding: 0 6px !important;
}


#dept_name {

  width: 220px !important;
}

#user_id {

  width: 180px !important;
}

#password {

  width: 180px !important;
}

#link_url_1 {

  width: 200px !important;
}

</style>
